import { t } from "i18next"
import { DateOnly } from "@/lib/date-only"
import { joinStrings } from "@/lib/joinString"
import { PRN_UNIT } from "@/modules/patients/detail/medication/types/medication-unit"
import { MedicationUnit } from "@/types/__generated__/union-types"

type MedicationDescription = {
  isActive: boolean
  unit: MedicationUnit
  morningDosage: number
  noonDosage: number
  eveningDosage: number
  nightDosage: number
  startDate: string | null
  endDate: string | null
  usageInstructions: string | null
}

export const generateMedicationDescription = ({
  isActive,
  unit,
  morningDosage,
  noonDosage,
  eveningDosage,
  nightDosage,
  startDate,
  endDate,
  usageInstructions,
}: MedicationDescription) => {
  const dosageFormat = joinStrings(
    [
      unit !== PRN_UNIT ? [morningDosage, noonDosage, eveningDosage, nightDosage].join("-") : "",
      t(`patient.medication.unitList.${unit}`),
    ],
    " ",
  )

  const activeMedicationDateFormat = startDate
    ? joinStrings([t("patient.medication.since"), new DateOnly(startDate).toDisplayableString()], " ")
    : ""

  const inactiveMedicationDateFormat =
    startDate && endDate
      ? joinStrings([new DateOnly(startDate).toDisplayableString(), new DateOnly(endDate).toDisplayableString()], " - ")
      : ""

  const medicationFormat = isActive ? activeMedicationDateFormat : inactiveMedicationDateFormat

  return joinStrings([medicationFormat, dosageFormat, usageInstructions])
}
